import { get, patch, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchCities = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        const params = new URLSearchParams();
        if (data.stateId) params.append("stateId", data.stateId);
        if (data.countryId) params.append("countryId", data.countryId);
        if (data.searchFilter) params.append("searchFilter", data.searchFilter);
        if (data.isFavourite !== undefined) params.append("isFavourite", data.isFavourite);
        if (data.isServiceableAttendant !== undefined) params.append("isServiceableAttendant", data.isServiceableAttendant);
        if (data.isServiceableTraveler !== undefined) params.append("isServiceableTraveler", data.isServiceableTraveler);

        return await get(`city/list?${params.toString()}`);
    }, options);
};

export const useAddCity = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (newCity: any) => {
        return await post("city", newCity);
    }, options);
};

export const useDeleteCity = (options: any) => {
    return useMutation(async (cityId) => {
        return await patch(`city/${cityId}/delete`, {});
    }, options);
};